import AlertComponent from '@mui/material/Alert';

function Alert(props) {
  return <AlertComponent elevation={6} variant='filled' {...props} />;
}

export default Alert;
